import React from 'react'

import TextMode from '../../assets/text-mode.svg'
import VideoMode from '../../assets/video-mode.svg'
import { Container, FormatWrapper, Wrapper, Modal } from './styles'

interface FirstAccerssModalProps {
  handleChangePreference(preference: 'video' | 'text'): void
}

const FirstAccessModal: React.FC<FirstAccerssModalProps> = ({ handleChangePreference }) => {
  return (
    <Modal>
      <Container>
        <h1>Como você prefere estudar?</h1>
        <p className="mobile">
          Essa opção poderá ser alterada depois em <b>Configurações</b>.
        </p>
        <p className="desktop">
          Nós disponibilizamos, o conteúdo no formato de texto e vídeo. Fique a vontade para
          escolher a sua forma preferida.
        </p>
        <Wrapper>
          <FormatWrapper isText onClick={() => handleChangePreference('text')}>
            <img src={TextMode} alt="Formato texto" />
            <h2>Formato texto</h2>
            <p>Elaboramos o conteudo ajustado para o formato de texto. São incríveis.</p>
            <span>Mais indicado</span>
          </FormatWrapper>
          <FormatWrapper onClick={() => handleChangePreference('video')} className="video">
            <img src={VideoMode} alt="Formato vídeo" />
            <h2>Formato vídeo</h2>
            <p>Aprenda com a didática e formato dos melhores professores do mercado.</p>
          </FormatWrapper>
        </Wrapper>
        <p className="desktop" style={{ marginTop: '1rem' }}>
          Essa opção poderá ser alterada depois em <b>Configurações</b>.
        </p>
      </Container>
    </Modal>
  )
}

export default FirstAccessModal
